<template>
   <v-container fluid class="fill-height hide-mouse">
    <template v-if="$vuetify.breakpoint.xs">
      <v-row no-gutters>
        <v-col cols="12" class="pa-6">
          <span ref="box" :class="changeCursor ?  'mdi mdi-cursor-default' : 'mdi mdi-cursor-text'" style="z-index:1;position:absolute;left:0;top:0;color:black;"></span>
          <p class="font-weight-black headline">账号密码登录</p>
          <v-form>
            <v-text-field ref="account" label="邮箱或手机号" v-model="account" full-width dense outlined></v-text-field>
            <v-text-field ref="password" label="密码" v-model="password" :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
              :type="show1 ? 'text' : 'password'" @click:append="show1 = !show1" full-width dense outlined></v-text-field>

            <v-checkbox v-model="rememberMe" label="记住我的信息"></v-checkbox>

            <v-btn ref="loginBtn" color="#000" dark block @click="login()">登录</v-btn>
            <p class="forget_password">忘记密码?</p>
          </v-form>
        </v-col>
        <v-col cols="12" style="padding-left: 45px;">
          <div class="login-box show-mobb">
            <h4 class="fontw-b">
              ETOAK会员相关权益
            </h4>
            <div>
              <p class="login-right-tlt">
                参与ETOAK技术深耕服务或成为ETOAK通用技术测试，即可享受会员页面</p>
              <div class="regist-inner">
                <div>
                  <v-icon>mdi-check-bold</v-icon> <span>您将获得最新技术应用详解范例</span>
                </div>
                <div>
                  <v-icon>mdi-check-bold</v-icon> <span>您将获得优质职场向导 & 猎头服务</span>
                </div>
                <div>
                  <v-icon>mdi-check-bold</v-icon> <span>您将获得优质的技术维护 & 技术支持</span>
                </div>
                <div>
                  <v-icon>mdi-check-bold</v-icon> <span>您将获得更高效的技术解决方案</span>
                </div>
                <div>
                  <v-icon>mdi-check-bold</v-icon> <span>您将获得完善的技术后备...</span>
                </div>
              </div>
            </div>
          </div>
        </v-col>
      </v-row>
    </template>
    <template v-else>
      <v-row justify="center">
        <v-col cols="6">
          <v-row>
            <v-col cols="12" md="6" class="login_password_panel">
              <span ref="box" :class="changeCursor ?  'mdi mdi-cursor-default' : 'mdi mdi-cursor-text'" style="z-index:1;position:absolute;left:0;top:0;color:black;"></span>
              <p class="font-weight-black headline">账号密码登录</p>
              <v-form>
                <v-text-field ref="account" label="邮箱或手机号" v-model="account" full-width dense outlined></v-text-field>
                <v-text-field ref="password" label="密码" v-model="password" :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                  :type="show1 ? 'text' : 'password'" @click:append="show1 = !show1" full-width dense outlined></v-text-field>

                <v-checkbox v-model="rememberMe" label="记住我的信息"></v-checkbox>

                <v-btn ref="loginBtn" color="#000" dark block >登录</v-btn>
                <p class="forget_password">忘记密码?</p>
              </v-form>
            </v-col>
            <v-col cols="12" md="6" style="padding-left: 60px;">
              <div class="login-box show-mobb">
                <h4 class="fontw-b">
                  ETOAK会员相关权益
                </h4>
                <div>
                  <p class="login-right-tlt">
                    参与ETOAK技术深耕服务或成为ETOAK通用技术测试，即可享受会员页面</p>
                  <div class="regist-inner">
                    <div>
                      <v-icon>mdi-check-bold</v-icon> <span>您将获得最新技术应用详解范例</span>
                    </div>
                    <div>
                      <v-icon>mdi-check-bold</v-icon> <span>您将获得优质职场向导 & 猎头服务</span>
                    </div>
                    <div>
                      <v-icon>mdi-check-bold</v-icon> <span>您将获得优质的技术维护 & 技术支持</span>
                    </div>
                    <div>
                      <v-icon>mdi-check-bold</v-icon> <span>您将获得更高效的技术解决方案</span>
                    </div>
                    <div>
                      <v-icon>mdi-check-bold</v-icon> <span>您将获得完善的技术后备...</span>
                    </div>
                  </div>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </template>
  </v-container>
</template>

<script>
  export default {
    name: 'login',
    data() {
      return {
        show1: false,
        rememberMe: true,
        account: "",
        password: "",
        timer: null,
        changeCursor: false,
        top: 0,
        left: 0
      }
    },
    mounted() {
      //this.doLogin();
      this.timer = setInterval(this.mouseMoveAcctFn, 5);
    },
    methods: {
      mouseMoveAcctFn() {
        const obj = this.$refs.account.$el.getBoundingClientRect();
        const _top = obj.top - obj.height;
        const _left = obj.left + obj.width / 2;
        if (this.top <= _top) {
          this.$refs.box.style.top = ++this.top + 'px';
        }
        if (this.left <= _left)
          this.$refs.box.style.left = ++this.left + 'px';
        if (this.top > _top && this.left > _left) {
          clearInterval(this.timer);
          this.doAcct();
        }

      },
      mouseMovePwdFn() {
        const obj = this.$refs.password.$el.getBoundingClientRect();
        const _top = obj.top - obj.height;
        const _left = obj.left + obj.width / 2;
        if (this.top <= _top) {
          this.$refs.box.style.top = ++this.top + 'px';
        }
        if (this.left <= _left)
          this.$refs.box.style.left = ++this.left + 'px';
        if (this.top > _top && this.left > _left) {
          clearInterval(this.timer);
          this.doPwd();
        }
      },
      mouseMoveLoginFn() {
        const obj = this.$refs.loginBtn.$el.getBoundingClientRect();
        //this.$refs.box.style.color = "white";
        const _top = obj.top - obj.height * 2;
        const _left = obj.left + obj.width / 2;
        if (this.top <= _top) {
          this.$refs.box.style.top = ++this.top + 'px';
        }
        if (this.left <= _left)
          this.$refs.box.style.left = ++this.left + 'px';
        if (this.top > _top && this.left > _left) {
          clearInterval(this.timer);
          this.login();
        }
      },

      doAcct() {
        setTimeout(() => {
          this.account += 'a';
        }, 300);
        setTimeout(() => {
          this.account += 'd';
        }, 500);
        setTimeout(() => {
          this.account += 'm';
        }, 700);
        setTimeout(() => {
          this.account += 'i';
        }, 900);
        setTimeout(() => {
          this.account += 'n';
          this.timer = setInterval(this.mouseMovePwdFn, 10);
        }, 1100);
      },
      doPwd() {
        setTimeout(() => {
          this.password += '*';
        }, 300);
        setTimeout(() => {
          this.password += '*';
        }, 500);
        setTimeout(() => {
          this.password += '*';
        }, 700);
        setTimeout(() => {
          this.password += '*';
        }, 900);
        setTimeout(() => {
          this.password += '*';
        }, 1100);
        setTimeout(() => {
          this.password += '*';
          this.timer = setInterval(this.mouseMoveLoginFn, 10);
        }, 1300);
        setTimeout(() => {
          this.changeCursor = true;
        }, 1500);
      },
      login() {
        clearInterval(this.timer);
        this.$router.push("home");
      }
    },
    components: {}
  }
</script>

<style scoped="scoped">
  .hide-mouse {
    cursor: none;
  }

  .login_password_panel {
    padding-right: 15%;
    border-right: 2px solid #EBEBEB;
  }

  .forget_password {
    text-decoration: underline;
    font-size: 14px;
    margin-top: 10px;
  }

  .regist-inner div {
    font-size: 14px;
    line-height: 14px;
    color: #000000;
    margin-bottom: 11px;
  }

  .regist-inner {
    margin: 40px 0 20px;
  }

  .fontw-b {
    font-size: 18px;
    color: #000000;
    line-height: 24px;
    margin-bottom: 20px;
  }

  .login-right-tlt {
    font-size: 14px;
    color: #000000;
    line-height: 18px;
  }
</style>



// WEBPACK FOOTER //
// src/page/account/login/login.vue